<template>
  <textarea
    :value="value"
    :placeholder="placeholder"
    :class="{ 'input--error': hasError }"
    class="input"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>


export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.input {
  width: 100%;
  box-sizing: border-box;
  padding: 16px 12px;
  border: 1px solid $color-navy-20;
  appearance: none;
  border-radius: 4px;
  color: $color-navy-70;
  font-size: $size-l;
  outline: none;
  transition: border-color $transition-base, background-color $transition-base;

  &:focus {
    border-color: $color-orange;
    background-color: $color-orange-light;
  }

  &::placeholder {
    color: $color-navy-20;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &--error {
    border-color: $color-strawberry;
    background-color: $color-strawberry-light;

    &:focus {
      border-color: $color-strawberry;
    }
  }
}
</style>
